'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
require('../Input/InputFormatted.js');
require('../Input/InputPassword.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Stepper = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('Stepper', props);
  var _omitThemingProps = react.omitThemingProps(props),
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var _useNumberInput = react.useNumberInput(_objectSpread({
      min: 0,
      defaultValue: 0
    }, rest)),
    getInputProps = _useNumberInput.getInputProps,
    getIncrementButtonProps = _useNumberInput.getIncrementButtonProps,
    getDecrementButtonProps = _useNumberInput.getDecrementButtonProps;
  var incrementButtonProps = getIncrementButtonProps();
  var decrementButtonProps = getDecrementButtonProps();
  var inputProps = getInputProps({
    readOnly: true
  });

  // Find out why the types don't fit.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var stackProps = utils.omit(rest, Object.keys(inputProps));
  return /*#__PURE__*/React__default["default"].createElement(react.HStack, _extends__default["default"]({}, stackProps, {
    __css: styles.container,
    className: utils.cx('chakra-stepper', className)
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.button, _extends__default["default"]({
    type: "button",
    __css: styles.button
  }, decrementButtonProps), "-"), /*#__PURE__*/React__default["default"].createElement(react.Input, _extends__default["default"]({
    variant: "unstyled",
    sx: styles.input
  }, inputProps, {
    ref: ref
  })), /*#__PURE__*/React__default["default"].createElement(react.chakra.button, _extends__default["default"]({
    type: "button",
    sx: styles.button
  }, incrementButtonProps), "+"));
});
Stepper.displayName = 'Stepper';
exports.Stepper = Stepper;